import { useTranslation } from "react-i18next";

import { NavPortal } from "components";

type NavCountProps = {
  total: number;
};

export const NavCount = ({ total }: NavCountProps) => {
  const { t } = useTranslation();

  return (
    <NavPortal containerId="navbar-count-portal-container">
      <span className="total-amount">{`${t("v8_total", "Total")}: ${total}`}</span>
    </NavPortal>
  );
};
